import { getPriceId, getRedirectLink, getOlderWebsiteSubscriptionPriceId } from '../../../catalog/Stripe';
import { functions } from '../../../firebase/FirebaseLibrary';
import { fetchWebsiteSubscriptionProductFirestoreAPI, fetchSubscriptionStatusFirestoreAPI, insertSubscriptionFirestoreAPI, fetchDomainSubscriptionProductFirestoreAPI, fetchDomainEmailSubscriptionProductFirestoreAPI, fetchTeamSubscriptionInfoFirestoreAPI } from '../../../firebase/firebaseAPICalls/FirebaseAPICallsSubscriptionInfo';
import { getSportsTypeName, SportsType } from '../../../catalog/enums/SportsType';
import { randomNumber } from '../../../catalog/Others';
import { insertMailFirestoreAPI } from '../../../firebase/firebaseAPICalls/FirebaseAPICallsMailerSendMail';
import { createSubscriptionMailObject } from '../../../catalog/mail/SubscriptionEmail';
import { sendCustomTeamAnalytics, sendErrorTeamAnalytics } from '../../../catalog/Analytics';
import { ERROR_FETCHING_ACCOUNT_SUBSCRIPTION_STATUS, ERROR_FETCHING_DOMAIN_EMAIL_SUBSCRIPTION_PRODUCT, ERROR_FETCHING_DOMAIN_SUBSCRIPTION_PRODUCT, ERROR_FETCHING_TEAM_SUBSCRIPTION_INFO, ERROR_FETCHING_WEBSITE_SUBSCRIPTION_PRODUCT, ERROR_INITIATING_SUBSCRIPTION } from '../../../catalog/NotificationComments';
import { SubscriptionDomainEmailObject } from '../../../catalog/interface/SubscriptionInfoInterface';
import { MailerSendMailObject } from '../../../catalog/interface/mailInterface/MailerSendMailInterface';
import { trackMetaPixelEvent } from '../../../catalog/MetaPixel';

export const fetchTeamSubscriptionInfoAPI = async (teamId: string, setState: Function, snackbar: Function) => {
    try {
        const teamSubscriptionInfoDoc = await fetchTeamSubscriptionInfoFirestoreAPI(teamId);
        const teamSubscriptionInfo = teamSubscriptionInfoDoc.data();
        setState({ type: 'setTeamSubscriptionInfo', info: teamSubscriptionInfo });
    } catch (error) {
        snackbar(ERROR_FETCHING_TEAM_SUBSCRIPTION_INFO, { variant: 'error' });
        sendErrorTeamAnalytics(ERROR_FETCHING_TEAM_SUBSCRIPTION_INFO);
    }
};

export const fetchWebsiteSubscriptionProductAPI = async (setState: Function, snackbar: Function) => {
    try {
        const productDoc = await fetchWebsiteSubscriptionProductFirestoreAPI();
        const priceDocs = await productDoc.ref.collection('prices').get();
        const prices: any = [];
        priceDocs.forEach((priceDoc: any) => {
            prices.push(priceDoc.data());
        });
        const product = { ...productDoc.data(), prices };
        setState({ type: 'setWebsiteProduct', product });
    } catch (error) {
        snackbar(ERROR_FETCHING_WEBSITE_SUBSCRIPTION_PRODUCT, { variant: 'error' });
        sendErrorTeamAnalytics(ERROR_FETCHING_WEBSITE_SUBSCRIPTION_PRODUCT);
    }
};

export const fetchDomainSubscriptionProductAPI = async (setState: Function, snackbar: Function) => {
    try {
        const productDoc = await fetchDomainSubscriptionProductFirestoreAPI();
        const priceDocs = await productDoc.ref.collection('prices').get();
        const prices: any = [];
        priceDocs.forEach((priceDoc: any) => {
            prices.push(priceDoc.data());
        });
        const product = { ...productDoc.data(), prices };
        setState({ type: 'setDomainProduct', product });
    } catch (error) {
        snackbar(ERROR_FETCHING_DOMAIN_SUBSCRIPTION_PRODUCT, { variant: 'error' });
        sendErrorTeamAnalytics(ERROR_FETCHING_DOMAIN_SUBSCRIPTION_PRODUCT);
    }
};

export const fetchDomainEmailSubscriptionProductAPI = async (setState: Function, snackbar: Function) => {
    try {
        const productDoc = await fetchDomainEmailSubscriptionProductFirestoreAPI();
        const priceDocs = await productDoc.ref.collection('prices').get();
        const prices: any = [];
        priceDocs.forEach((priceDoc: any) => {
            prices.push(priceDoc.data());
        });
        const product = { ...productDoc.data(), prices };
        setState({ type: 'setEmailProduct', product });
    } catch (error) {
        snackbar(ERROR_FETCHING_DOMAIN_EMAIL_SUBSCRIPTION_PRODUCT, { variant: 'error' });
        sendErrorTeamAnalytics(ERROR_FETCHING_DOMAIN_EMAIL_SUBSCRIPTION_PRODUCT);
    }
};

export const fetchSubscriptionStatusAPI = async (teamId: string, setState: Function, snackbar: Function) => {
    const subscriptions: any = [];
    try {
        const docs = await fetchSubscriptionStatusFirestoreAPI(teamId);
        docs.forEach((doc) => {
            if (doc.exists) {
                subscriptions.push(doc.data());
            }
        });
        let websiteSubscriptionActive = false;
        let websiteSubscriptionExists = false;
        let websiteSubscription = {};
        let domainSubscriptionActive = false;
        let domainSubscriptionExists = false;
        let domainSubscription = {};
        let emailSubscriptionActive = false;
        let emailSubscriptionExists = false;
        let emailSubscription = {};

        subscriptions.forEach((subscription: any) => {
            const prices = subscription.prices.map((price: any) => {
                return price.id;
            });
            if (prices.includes(getPriceId(true, false, false, true))
            || prices.includes(getPriceId(true, false, false, false))
            || prices.includes(getOlderWebsiteSubscriptionPriceId(true))
            || prices.includes(getOlderWebsiteSubscriptionPriceId(false))) {
                if (subscription.status === 'active' || subscription.status === 'trialing') {
                    websiteSubscriptionActive = true;
                }
                websiteSubscriptionExists = true;
                websiteSubscription = subscription;
            }
            if (prices.includes(getPriceId(false, true, false, true)) || prices.includes(getPriceId(false, true, false, false))) {
                if ((subscription.status === 'active' || subscription.status === 'trialing')) {
                    domainSubscriptionActive = true;
                }
                domainSubscriptionExists = true;
                domainSubscription = subscription;
            }
            if (prices.includes(getPriceId(false, false, true, true)) || prices.includes(getPriceId(false, false, true, false))) {
                if (subscription.status === 'active' || subscription.status === 'trialing') {
                    emailSubscriptionActive = true;
                }
                emailSubscriptionExists = true;
                emailSubscription = subscription;
            }
        });
        setState({ type: 'setSubscriptionActive',
            websiteSubscriptionActive,
            websiteSubscriptionExists,
            websiteSubscription,
            domainSubscriptionActive,
            domainSubscriptionExists,
            domainSubscription,
            emailSubscriptionActive,
            emailSubscriptionExists,
            emailSubscription,
        });
    } catch (error) {
        snackbar(ERROR_FETCHING_ACCOUNT_SUBSCRIPTION_STATUS, { variant: 'error' });
        sendErrorTeamAnalytics(ERROR_FETCHING_ACCOUNT_SUBSCRIPTION_STATUS);
    }
};

export const insertSubscriptionAPI = async (
    teamId: string,
    teamName: string,
    organizationId: string,
    organizationName: string,
    sportsType: SportsType,
    email: string,
    url: string,
    priceId: string,
    quantity: number,
    subscriptionType: 'Website' | 'Domain' | 'Email',
    metadata: SubscriptionDomainEmailObject[],
    successRedirectLink: string,
    cancelRedirectLink: string,
    setState: Function,
    snackbar: Function,
    trialPeriodDays = 0,
    useDirectCheckout = false,
    price: { [key: string]: any } = {}, // Stripe price doc (unit_amount in cents, currency)
) => {
    try {
        const mailId = randomNumber();
        const mailObject: MailerSendMailObject = createSubscriptionMailObject(mailId, teamId, teamName, organizationId, organizationName, sportsType, subscriptionType, metadata, email, url);
        await insertMailFirestoreAPI(mailObject);
        sendCustomTeamAnalytics(`subscription_${subscriptionType.toLowerCase()}`);
        trackMetaPixelEvent('InitiateCheckout', { content_name: subscriptionType });
        // checkout=success lets PixelTracker fire a Subscribe event on return
        // from Stripe; the cancel URL stays param-free to tell the two apart.
        // value/currency ride along because Meta rejects Subscribe without them
        // (for a free trial this is the plan price the trial converts into).
        const checkoutParams = new URLSearchParams({ checkout: 'success' });
        const checkoutValue = ((price.unit_amount || 0) / 100) * quantity;
        if (checkoutValue > 0) {
            checkoutParams.set('value', checkoutValue.toFixed(2));
            checkoutParams.set('currency', (price.currency || 'usd').toUpperCase());
        }
        const checkoutSuccessUrl = `${getRedirectLink(successRedirectLink)}?${checkoutParams.toString()}`;
        if (useDirectCheckout) {
            const createCheckout = functions.httpsCallable('createSubscriptionCheckoutSession');
            const result: any = await createCheckout({
                priceId,
                quantity,
                trialPeriodDays,
                successUrl: checkoutSuccessUrl,
                cancelUrl: getRedirectLink(cancelRedirectLink),
                metadata: { teamName, organizationId, organizationName, sportsType: getSportsTypeName(sportsType), email, url },
            });
            if (result?.data?.url) {
                window.location.assign(result.data.url);
            } else {
                snackbar(ERROR_INITIATING_SUBSCRIPTION, { variant: 'error' });
                sendErrorTeamAnalytics(ERROR_INITIATING_SUBSCRIPTION);
                setState({ type: `set${subscriptionType}SubscriptionLoadingSpinner`, loadingSpinner: false });
            }
            return;
        }
        const insertSubscriptionDoc = await insertSubscriptionFirestoreAPI(teamId, [priceId], [quantity], checkoutSuccessUrl, getRedirectLink(cancelRedirectLink), { teamId, teamName, organizationId, organizationName, sportsType: getSportsTypeName(sportsType), email, url }, trialPeriodDays);
        insertSubscriptionDoc.onSnapshot((subscriptionDoc) => {
            const subscription = subscriptionDoc.data();
            if (subscription?.error) {
                snackbar(subscription?.error.message, { variant: 'error' });
                sendErrorTeamAnalytics(subscription?.error.message);
                setState({ type: `set${subscriptionType}SubscriptionLoadingSpinner`, loadingSpinner: false });
            }
            if (subscription?.url) {
                window.location.assign(subscription?.url);
            }
        });
    } catch (error) {
        snackbar(ERROR_INITIATING_SUBSCRIPTION, { variant: 'error' });
        sendErrorTeamAnalytics(ERROR_INITIATING_SUBSCRIPTION);
        setState({ type: `set${subscriptionType}SubscriptionLoadingSpinner`, loadingSpinner: false });
    }
};

export const manageSubscriptionAPI = async (redirectLink: string) => {
    const functionRef = functions.httpsCallable('ext-firestore-stripe-payments-createPortalLink');
    const { data } = await functionRef({ returnUrl: getRedirectLink(redirectLink) });
    window.location.assign(data.url);
};
